import _JSXStyle from "styled-jsx/style";
import { colors, theme } from '@dhis2/ui-constants';
import { Tooltip } from '@dhis2-ui/tooltip';
import PropTypes from 'prop-types';
import React from 'react';
const InputClearButton = _ref => {
  let {
    onClear,
    clearText,
    className,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement(Tooltip, {
    openDelay: 500,
    content: clearText
  }, /*#__PURE__*/React.createElement("button", {
    "data-test": dataTest,
    onClick: onClear,
    type: "button",
    className: _JSXStyle.dynamic([["2606883952", [colors.grey500, colors.grey800, colors.grey200, theme.focus]]]) + " " + (className || "")
  }, /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: _JSXStyle.dynamic([["2606883952", [colors.grey500, colors.grey800, colors.grey200, theme.focus]]])
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm3.536-5.879a1 1 0 1 1-1.415 1.414l-2.12-2.12-2.122 2.121a1 1 0 1 1-1.415-1.414L6.586 8 4.464 5.878A1 1 0 1 1 5.88 4.464L8 6.586l2.121-2.121a1 1 0 1 1 1.415 1.414L9.415 8l2.12 2.121Z",
    fill: "none",
    className: _JSXStyle.dynamic([["2606883952", [colors.grey500, colors.grey800, colors.grey200, theme.focus]]])
  })), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2606883952",
    dynamic: [colors.grey500, colors.grey800, colors.grey200, theme.focus]
  }, ["button.__jsx-style-dynamic-selector{background:none;border:none;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;height:24px;width:24px;border-radius:3px;}", `button.__jsx-style-dynamic-selector svg.__jsx-style-dynamic-selector path.__jsx-style-dynamic-selector{fill:${colors.grey500};}`, `button.__jsx-style-dynamic-selector:hover svg.__jsx-style-dynamic-selector path.__jsx-style-dynamic-selector{fill:${colors.grey800};}`, `button.__jsx-style-dynamic-selector:hover{background:${colors.grey200};}`, `button.__jsx-style-dynamic-selector:focus{outline:2px solid ${theme.focus};}`])));
};
InputClearButton.propTypes = {
  clearText: PropTypes.string.isRequired,
  dataTest: PropTypes.string.isRequired,
  onClear: PropTypes.func.isRequired,
  className: PropTypes.string
};
export { InputClearButton };